import axios from 'axios'
import { ElMessage } from 'element-plus'
import { ZF_NO } from '@mp/constant'
import { generateBodySignInterceptor, getDeviceCode, getPublicKey } from '@mp/utils'

const http = axios.create()
http.defaults.timeout = 300000
http.defaults.baseURL = import.meta.env.VITE_SDPMCHAUTH
http.defaults.method = 'post'

http.interceptors.request.use(
  async (config: any) => {
    // 加密拦截器先执行时会写入 _publicKeyRes，此处复用同一份公钥，避免过期边界两次 getPublicKey 不一致
    const publicKeyRes = config._publicKeyRes ?? await getPublicKey()
    config._publicKeyRes = publicKeyRes

    config.headers = {
      ...config.headers,
      'appId': ZF_NO,
      'subAppId': ZF_NO,
      'X-Sdp-Cs-No': publicKeyRes.keySerialNo ?? '',
      'deviceId': await getDeviceCode(),
    }

    config.data = {
      ...config.data,
      appId: ZF_NO,
      requestTime: new Date().getTime(),
      requestNo: String(new Date().getTime()),
    }

    return config
  },
  (error: any) => {
    return Promise.reject(error)
  },
)

http.interceptors.request.use(generateBodySignInterceptor())


// 响应拦截器
http.interceptors.response.use(
  (response) => {
    const res = response.data

    if (res?.errorCodeDes?.includes('应用或者证书编号错误')) {
      sessionStorage.removeItem('publicKeyRes')
      return Promise.reject(res)
    }

    if (res?.resultCode === 'FAIL') {
      res.errorCodeDes && ElMessage({ message: res.errorCodeDes, type: 'error' })
      return Promise.reject(res)
    }

    return res
  },
  (error) => {
    if (error?.response?.status === 500)
      sessionStorage.removeItem('publicKeyRes')

    return Promise.reject(error)
  },
)

export default http
